import { ref } from 'vue'

function normalizeRole(role) {
    return (
        role === 'ROLE_CUSTOMER' ||
        role === 'ROLE_ADMIN' ||
        role === 'ROLE_EMPLOYER'
    ) ? role : null
}

// Khởi tạo từ localStorage
export const authRole = ref(
    normalizeRole(localStorage.getItem('role'))
)

export function setAuthRole(role) {
    const normalized = normalizeRole(role)

    // LOGIN
    if (normalized) {
        localStorage.setItem('role', normalized)
        localStorage.setItem('isAuthenticated', 'true')
        authRole.value = normalized
        return
    }

    // LOGOUT (chỉ clear khi thật sự logout)
    localStorage.removeItem('role')
    localStorage.removeItem('isAuthenticated')
    localStorage.removeItem('accessToken')
    authRole.value = null
}
